function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { recordServiceSelected } from 'researcher/helpers/gtm';
import trackRubriqEvent from 'rubriq/helpers/trackRubriqEvent';
var getCurrentPlanName = function getCurrentPlanName(curie, hasActivePlan) {
  var _curie$subscription, _curie$subscription2;
  var activePlanName = (curie === null || curie === void 0 ? void 0 : curie.activePlanName) || (curie === null || curie === void 0 ? void 0 : curie.planName) || (curie === null || curie === void 0 || (_curie$subscription = curie.subscription) === null || _curie$subscription === void 0 ? void 0 : _curie$subscription.planName);
  if (!hasActivePlan || !activePlanName) {
    return 'No active plan';
  }
  var isTrialActive = (curie === null || curie === void 0 ? void 0 : curie.isTrialActive) || (curie === null || curie === void 0 || (_curie$subscription2 = curie.subscription) === null || _curie$subscription2 === void 0 ? void 0 : _curie$subscription2.isTrial);
  return isTrialActive ? "".concat(activePlanName, " (Trial)") : activePlanName;
};
var usePricingAnalytics = function usePricingAnalytics(_ref) {
  var hasActivePlan = _ref.hasActivePlan;
  var user = useSelector(function (state) {
    return state.user;
  });
  var curie = useSelector(function (state) {
    return state.curie;
  });
  var trialPlanUsed = (curie === null || curie === void 0 ? void 0 : curie.alreadyTriedUser) || false;
  var baseProperties = function baseProperties() {
    return {
      user_email: (user === null || user === void 0 ? void 0 : user.email) || null,
      email: (user === null || user === void 0 ? void 0 : user.email) || null,
      user_identity: user.identity,
      device: navigator.userAgent
    };
  };
  useEffect(function () {
    trackRubriqEvent('Pricing Page Viewed', _objectSpread(_objectSpread({}, baseProperties()), {}, {
      landing_page: window.location.pathname,
      has_active_plan: hasActivePlan,
      trial_plan_used: trialPlanUsed,
      planName: getCurrentPlanName(curie, hasActivePlan)
    }));
  }, []);
  var trackBillingIntervalSelected = function trackBillingIntervalSelected(billingInterval) {
    return trackRubriqEvent('Duration Selected', _objectSpread(_objectSpread({}, baseProperties()), {}, {
      billing_cycle: billingInterval
    }));
  };
  var trackCheckoutStarted = function trackCheckoutStarted(_ref2) {
    var buttonId = _ref2.buttonId,
      productName = _ref2.productName,
      plan = _ref2.plan;
    recordServiceSelected({
      buttonId: buttonId,
      productName: productName
    });
    trackRubriqEvent('Plan Selected', _objectSpread(_objectSpread({}, baseProperties()), {}, {
      planName: productName,
      landing_page: window.location.pathname
    }));
    trackRubriqEvent('Checkout Started', _objectSpread(_objectSpread({}, baseProperties()), {}, {
      page: window.location.pathname,
      trial_plan_used: trialPlanUsed,
      planName: productName,
      price: plan.price,
      billing_cycle: plan.billingInterval
    }));
  };
  var trackPlanSelected = function trackPlanSelected(productName) {
    return trackRubriqEvent('Plan Selected', _objectSpread(_objectSpread({}, baseProperties()), {}, {
      planName: productName,
      landing_page: window.location.pathname
    }));
  };
  return {
    trialPlanUsed: trialPlanUsed,
    trackBillingIntervalSelected: trackBillingIntervalSelected,
    trackCheckoutStarted: trackCheckoutStarted,
    trackPlanSelected: trackPlanSelected
  };
};
export default usePricingAnalytics;